// extracted by mini-css-extract-plugin
export default {"filters":"Filters_filters__7NCAJ","first":"Filters_first__JJgfn","second":"Filters_second__O66pl","spantype":"Filters_spantype__aiCJ2"};